<div class="form-row with-padding-bottom radio-row">
	<div class="radio-column">
		<nb-radio id="hasCertificateRadio-{{standardName()}}" [name]="'hasCertificateRadio' + RANDOM_NUMBER" [checked]="true" status="primary">
			{{ hasCertificate | booleanDisplay }}
		</nb-radio>
	</div>
	<div class="radio-description-column">
		{{ 'product-details.transfer-questions.is-transfer' | translate: {standard: product.standard.name | standardName} }}
	</div>
</div>

@if (hasCertificate) {
	<div class="client-property-label">
		<span>{{ 'product-details.transfer-questions.previous-cb' | translate }}</span>
		<change-label [visible]="isOtherCbChanged()" [changeSet]="changeSet"></change-label>
	</div>
	<div id="current-certification-body-{{standardName()}}" class="client-property">
		{{ currentCertificationBody }}
	</div>
	<div class="client-property-label">
		<span>{{ 'product-details.transfer-questions.last-audit-event' | translate }}</span>
		<change-label [visible]="isLastAuditEventChanged()" [changeSet]="changeSet"></change-label>
	</div>
	<div id="current-certification-last-audit-event-{{standardName()}}" class="client-property">
		<span>{{ currentCertificationLastAuditEvent | auditType | async }}</span>
	</div>
}
